import { axiosClient } from '../../../shared/api';

export const listAuditLogs = async (query = '') => {
  const response = await axiosClient.get(`/audit-logs${query}`);
  return response.data;
};

export const getAuditStats = async () => {
  const response = await axiosClient.get('/audit-logs/stats');
  return response.data;
};
